import React from "react"
import Block from "@bappweb/block"
import Element from "@bappweb/element"
import Image from "@bappweb/image"
import "../assets/style.scss"
import { useDeviceSize } from "@bappweb/provider"
import { getDeviceTypeFromSize } from "@smpu-web/utils/utils"

const LandingHeader = () => {
  const size = useDeviceSize();
  const deviceType = getDeviceTypeFromSize(size);

  return (
    <Block type="header" className="landing-header-container">
      <Block className="landing-header-text-wrapper bapp-container">
        <Block className="landing-header-text">
          <Element type="h2">{"POS Bloke Transfer ile avantajlı koşullarla finansman ihtiyacınızı karşılayın"}</Element>
          <Element type="p">{"Hemen mobilden Akbanklı olun, POS Bloke Transfer tutarını vadesinden önce hesabınıza aktarma fırsatı yakalayın."}</Element>
        </Block>
      </Block>
      {deviceType === "M" &&
        <Image path={"./img/poscek/poscek-banner-mobile.jpg"} className="landing-header-img" />
      }
      {deviceType !== "M" &&
        <Image path={"./img/poscek/poscek-banner.jpg"} className="landing-header-img" />
      }
    </Block>
  )
}

export default LandingHeader
